import { render, staticRenderFns } from "./ptAccountList.vue?vue&type=template&id=2f92e223"
import script from "./ptAccountList.vue?vue&type=script&lang=js"
export * from "./ptAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports